import {
  SContainer,
  SDescription,
  SImage,
  SJobTitle,
  SName,
} from './DigitalLegacyReviewItem.styled'
import AmazonStars from 'images/extra-svg/AmazonStars4_5.svg'

export function DigitalLegacyReviewItem(props: {
  src?: string | null
  srcSet?: string | null
  name?: string | null
  description?: string | null
  jobTitle?: string | null
}) {
  return (
    <SContainer>
      {props.src && (
        <SImage src={props.src} srcSet={props.srcSet ?? undefined} alt={props.name ?? undefined} />
      )}
      <SDescription>{props.description}</SDescription>
      <SName>{props.name}</SName>
      <SJobTitle>{props.jobTitle}</SJobTitle>
      <AmazonStars />
    </SContainer>
  )
}
